import apiFetch from '../apiFetch'

export default function (token, templateId, languageId) {
  return apiFetch({ endPoint: `Template/${templateId}/File?languageId=${languageId}`, method: 'GET', parseBlobAndAssign: true, token: token })
}
